import React from 'react';

import { useSelector } from 'hooks';
import { getFollowingStep } from 'utils/stepUtils';
import { getContext } from 'modules/dealers/selectors';
import { getStepsConfig } from 'modules/selfServices/stepsConfigSelectors';
import { getSelectedSelfServiceId } from 'modules/auth/selectors';
import { useGetSelfServiceByIdQuery } from 'modules/selfServices/service';
import { PartteamModel, ShareboxModel } from 'types/KioskTypes';

import KioskReopenFlow from './kiosk';
import { isVisibleStep } from '../../SelfServices/Steps/utils';

import type { SelfServiceStep } from '../../SelfServices/types';

const useReopenSteps = () => {
  const { kioskType, kioskModel } = useSelector(getContext);
  const config = useSelector(getStepsConfig);
  const selfServiceId = useSelector(getSelectedSelfServiceId);

  const { data: selfService } = useGetSelfServiceByIdQuery({ id: selfServiceId });

  const flowsByKioskType = KioskReopenFlow[kioskType];

  const steps = Object.values(flowsByKioskType[kioskModel as (ShareboxModel & PartteamModel)]) as Array<SelfServiceStep>;
  const visibleSteps = React.useMemo(() => steps.filter((step) => isVisibleStep(step, selfService, config)), [config, selfService, steps]);

  return React.useMemo(() => visibleSteps.map((step) => ({
    ...step,
    next: getFollowingStep<SelfServiceStep>(step, visibleSteps, steps),
    previous: getFollowingStep<SelfServiceStep>(step, visibleSteps, steps, 'previous'),
  })), [steps, visibleSteps]);
};

export default useReopenSteps;
